﻿export module text {
    export var loading: string = 'Laddar...'
    export var loadingPage: string = 'Laddar sida...'
    export var serviceDisabled: string = 'Denna funktion ingår inte i ditt nuvarande abonnemang - Kontakta oss för mer information och en demonstration över vad denna funktion innehåller.'
}

export module url {
    export module account {
        export var logIn: string = '/Account/LogIn'
        export var loginUsingToken: string = '/Account/LoginUsingToken'
        export var changePassword: string = '/Account/ChangePassword'
        export var myPageSave: string = '/Account/MyPageSave'
        export var myPageCodes: string = '/Account/MyPageCodes'
        export var changePasswordExternal: string = '/Account/ChangePasswordExternal'
        export var forgottenPassword: string = '/Account/ForgottenPassword'
        export var sendDeleteCodeMail: string = '/Account/SendDeleteCodeMail'
        export var deleteCode: string = '/Account/DeleteCode'
    }
    export module search {
        export var owner: string = '/Search/OwnerForm'
    }
}
